import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = [
    "modal",
    "firstNameInput",
    "lastNameInput",
    "emailInput",
    "submitButton",
    "timingInput",
    "dateField",
    "dateInput",
    "description"
  ];
  static values = {
    open: { type: Boolean, default: false }
  };

  connect() {
    if (this.openValue) {
      this.showModal();
    }

    this.validate();
  }

  open(event) {
    event.preventDefault();
    this.showModal();
  }

  showModal() {
    Modal.getOrCreateInstance(this.modalTarget).show();
  }

  modalShown() {
    if (this.hasFirstNameInputTarget) {
      this.firstNameInputTarget.focus();
    }

    this.timingChanged();
    this.validate();
  }

  timingChanged() {
    const later = this.schedulingLater();

    if (this.hasDateFieldTarget) {
      this.dateFieldTarget.hidden = !later;
    }

    if (this.hasDateInputTarget) {
      this.dateInputTarget.disabled = !later;
      if (!later) this.dateInputTarget.value = "";
    }

    if (this.hasDescriptionTarget) {
      const copy = later
        ? this.descriptionTarget.dataset.laterCopy
        : this.descriptionTarget.dataset.nowCopy;
      if (copy) this.descriptionTarget.textContent = copy;
    }

    this.validate();
  }

  modalHidden() {
    this.openValue = false;
    this.validate();
  }

  validate() {
    if (!this.hasSubmitButtonTarget) return;

    this.submitButtonTarget.disabled = !this.formValid();
  }

  formValid() {
    if (!this.hasModalTarget) return false;

    const firstName = this.hasFirstNameInputTarget ? this.firstNameInputTarget.value.trim() : "";
    const lastName = this.hasLastNameInputTarget ? this.lastNameInputTarget.value.trim() : "";
    const email = this.hasEmailInputTarget ? this.emailInputTarget.value.trim() : "";
    const roleSelected = this.modalTarget.querySelector('input[name="company_member[roles][]"]:checked');
    const accessLevelInput = this.modalTarget.querySelector('[name="company_member[access_level]"]');
    const accessLevel = accessLevelInput ? accessLevelInput.value.trim() : "";

    if (firstName === "" || lastName === "" || email === "" || roleSelected === null || accessLevel === "") {
      return false;
    }

    if (!this.schedulingLater()) return true;

    return this.hasDateInputTarget && this.dateInputTarget.value !== "";
  }

  schedulingLater() {
    if (!this.hasTimingInputTarget) return false;

    return this.timingInputTargets.some((input) => input.checked && input.value === "later");
  }
}
